import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IAutomatedActionSharingItemsListData } from './action-sharing-items-list-dialog.component';
import { FiImageSize } from '@fi-shared/types';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';

@Component({
    selector: 'fi-automated-action-sharing-items-list',
    template: `
        @for (displayedItem of items; track displayedItem.Name) {
            <div class="displayed-item-wrapper">
                @if (displayedItem.ProfileData) {
                    <fi-profile-icon
                        class="displayed-item-profile-icon"
                        [profileData]="displayedItem.ProfileData"
                        [size]="FiProfileSizes.Size40px"
                        [imageSize]="FiImageSize.Thumbnail"
                    />
                }

                <span class="displayed-item-name">{{ displayedItem.Name }}</span>
            </div>
        }
    `,
    styleUrls: ['./action-sharing-items-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-action-sharing-items-list' },
    standalone: false,
})
export class FiAutomatedActionSharingItemsListComponent {
    @Input() items: IAutomatedActionSharingItemsListData[] = [];
    protected readonly FiImageSize = FiImageSize;
    protected readonly FiProfileSizes = FiProfileSizes;
}
